import {defineMessages} from 'react-intl'

export const usStateMessages = defineMessages({
    'state.us.alabama': {
        id: 'state.us.alabama',
        defaultMessage: 'Alabama'
    },
    'state.us.alaska': {
        id: 'state.us.alaska',
        defaultMessage: 'Alaska'
    },
    'state.us.american_samoa': {
        id: 'state.us.american_samoa',
        defaultMessage: 'American Samoa'
    },
    'state.us.arizona': {
        id: 'state.us.arizona',
        defaultMessage: 'Arizona'
    },
    'state.us.arkansas': {
        id: 'state.us.arkansas',
        defaultMessage: 'Arkansas'
    },
    'state.us.california': {
        id: 'state.us.california',
        defaultMessage: 'California'
    },
    'state.us.colorado': {
        id: 'state.us.colorado',
        defaultMessage: 'Colorado'
    },
    'state.us.connecticut': {
        id: 'state.us.connecticut',
        defaultMessage: 'Connecticut'
    },
    'state.us.delaware': {
        id: 'state.us.delaware',
        defaultMessage: 'Delaware'
    },
    'state.us.district_of_columbia': {
        id: 'state.us.district_of_columbia',
        defaultMessage: 'District Of Columbia'
    },
    'state.us.florida': {
        id: 'state.us.florida',
        defaultMessage: 'Florida'
    },
    'state.us.georgia': {
        id: 'state.us.georgia',
        defaultMessage: 'Georgia'
    },
    'state.us.guam': {
        id: 'state.us.guam',
        defaultMessage: 'Guam'
    },
    'state.us.hawaii': {
        id: 'state.us.hawaii',
        defaultMessage: 'Hawaii'
    },
    'state.us.idaho': {
        id: 'state.us.idaho',
        defaultMessage: 'Idaho'
    },
    'state.us.illinois': {
        id: 'state.us.illinois',
        defaultMessage: 'Illinois'
    },
    'state.us.indiana': {
        id: 'state.us.indiana',
        defaultMessage: 'Indiana'
    },
    'state.us.iowa': {
        id: 'state.us.iowa',
        defaultMessage: 'Iowa'
    },
    'state.us.kansas': {
        id: 'state.us.kansas',
        defaultMessage: 'Kansas'
    },
    'state.us.kentucky': {
        id: 'state.us.kentucky',
        defaultMessage: 'Kentucky'
    },
    'state.us.louisiana': {
        id: 'state.us.louisiana',
        defaultMessage: 'Louisiana'
    },
    'state.us.maine': {
        id: 'state.us.maine',
        defaultMessage: 'Maine'
    },
    'state.us.maryland': {
        id: 'state.us.maryland',
        defaultMessage: 'Maryland'
    },
    'state.us.massachusetts': {
        id: 'state.us.massachusetts',
        defaultMessage: 'Massachusetts'
    },
    'state.us.michigan': {
        id: 'state.us.michigan',
        defaultMessage: 'Michigan'
    },
    'state.us.minnesota': {
        id: 'state.us.minnesota',
        defaultMessage: 'Minnesota'
    },
    'state.us.mississippi': {
        id: 'state.us.mississippi',
        defaultMessage: 'Mississippi'
    },
    'state.us.missouri': {
        id: 'state.us.missouri',
        defaultMessage: 'Missouri'
    },
    'state.us.montana': {
        id: 'state.us.montana',
        defaultMessage: 'Montana'
    },
    'state.us.nebraska': {
        id: 'state.us.nebraska',
        defaultMessage: 'Nebraska'
    },
    'state.us.nevada': {
        id: 'state.us.nevada',
        defaultMessage: 'Nevada'
    },
    'state.us.new_hampshire': {
        id: 'state.us.new_hampshire',
        defaultMessage: 'New Hampshire'
    },
    'state.us.new_jersey': {
        id: 'state.us.new_jersey',
        defaultMessage: 'New Jersey'
    },
    'state.us.new_mexico': {
        id: 'state.us.new_mexico',
        defaultMessage: 'New Mexico'
    },
    'state.us.new_york': {
        id: 'state.us.new_york',
        defaultMessage: 'New York'
    },
    'state.us.north_carolina': {
        id: 'state.us.north_carolina',
        defaultMessage: 'North Carolina'
    },
    'state.us.north_dakota': {
        id: 'state.us.north_dakota',
        defaultMessage: 'North Dakota'
    },
    'state.us.northern_mariana_islands': {
        id: 'state.us.northern_mariana_islands',
        defaultMessage: 'Northern Mariana Islands'
    },
    'state.us.ohio': {
        id: 'state.us.ohio',
        defaultMessage: 'Ohio'
    },
    'state.us.oklahoma': {
        id: 'state.us.oklahoma',
        defaultMessage: 'Oklahoma'
    },
    'state.us.oregon': {
        id: 'state.us.oregon',
        defaultMessage: 'Oregon'
    },
    'state.us.pennsylvania': {
        id: 'state.us.pennsylvania',
        defaultMessage: 'Pennsylvania'
    },
    'state.us.puerto_rico': {
        id: 'state.us.puerto_rico',
        defaultMessage: 'Puerto Rico'
    },
    'state.us.rhode_island': {
        id: 'state.us.rhode_island',
        defaultMessage: 'Rhode Island'
    },
    'state.us.south_carolina': {
        id: 'state.us.south_carolina',
        defaultMessage: 'South Carolina'
    },
    'state.us.south_dakota': {
        id: 'state.us.south_dakota',
        defaultMessage: 'South Dakota'
    },
    'state.us.tennessee': {
        id: 'state.us.tennessee',
        defaultMessage: 'Tennessee'
    },
    'state.us.texas': {
        id: 'state.us.texas',
        defaultMessage: 'Texas'
    },
    'state.us.utah': {
        id: 'state.us.utah',
        defaultMessage: 'Utah'
    },
    'state.us.vermont': {
        id: 'state.us.vermont',
        defaultMessage: 'Vermont'
    },
    'state.us.virgin_islands': {
        id: 'state.us.virgin_islands',
        defaultMessage: 'Virgin Islands'
    },
    'state.us.virginia': {
        id: 'state.us.virginia',
        defaultMessage: 'Virginia'
    },
    'state.us.washington': {
        id: 'state.us.washington',
        defaultMessage: 'Washington'
    },
    'state.us.west_virginia': {
        id: 'state.us.west_virginia',
        defaultMessage: 'West Virginia'
    },
    'state.us.wisconsin': {
        id: 'state.us.wisconsin',
        defaultMessage: 'Wisconsin'
    },
    'state.us.wyoming': {
        id: 'state.us.wyoming',
        defaultMessage: 'Wyoming'
    }
})

// Replace labels with message IDs
export const usStateOptions = [
    {value: 'AL', label: 'state.us.alabama'},
    {value: 'AK', label: 'state.us.alaska'},
    {value: 'AS', label: 'state.us.american_samoa'},
    {value: 'AZ', label: 'state.us.arizona'},
    {value: 'AR', label: 'state.us.arkansas'},
    {value: 'CA', label: 'state.us.california'},
    {value: 'CO', label: 'state.us.colorado'},
    {value: 'CT', label: 'state.us.connecticut'},
    {value: 'DE', label: 'state.us.delaware'},
    {value: 'DC', label: 'state.us.district_of_columbia'},
    {value: 'FL', label: 'state.us.florida'},
    {value: 'GA', label: 'state.us.georgia'},
    {value: 'GU', label: 'state.us.guam'},
    {value: 'HI', label: 'state.us.hawaii'},
    {value: 'ID', label: 'state.us.idaho'},
    {value: 'IL', label: 'state.us.illinois'},
    {value: 'IN', label: 'state.us.indiana'},
    {value: 'IA', label: 'state.us.iowa'},
    {value: 'KS', label: 'state.us.kansas'},
    {value: 'KY', label: 'state.us.kentucky'},
    {value: 'LA', label: 'state.us.louisiana'},
    {value: 'ME', label: 'state.us.maine'},
    {value: 'MD', label: 'state.us.maryland'},
    {value: 'MA', label: 'state.us.massachusetts'},
    {value: 'MI', label: 'state.us.michigan'},
    {value: 'MN', label: 'state.us.minnesota'},
    {value: 'MS', label: 'state.us.mississippi'},
    {value: 'MO', label: 'state.us.missouri'},
    {value: 'MT', label: 'state.us.montana'},
    {value: 'NE', label: 'state.us.nebraska'},
    {value: 'NV', label: 'state.us.nevada'},
    {value: 'NH', label: 'state.us.new_hampshire'},
    {value: 'NJ', label: 'state.us.new_jersey'},
    {value: 'NM', label: 'state.us.new_mexico'},
    {value: 'NY', label: 'state.us.new_york'},
    {value: 'NC', label: 'state.us.north_carolina'},
    {value: 'ND', label: 'state.us.north_dakota'},
    {value: 'MP', label: 'state.us.northern_mariana_islands'},
    {value: 'OH', label: 'state.us.ohio'},
    {value: 'OK', label: 'state.us.oklahoma'},
    {value: 'OR', label: 'state.us.oregon'},
    {value: 'PA', label: 'state.us.pennsylvania'},
    {value: 'PR', label: 'state.us.puerto_rico'},
    {value: 'RI', label: 'state.us.rhode_island'},
    {value: 'SC', label: 'state.us.south_carolina'},
    {value: 'SD', label: 'state.us.south_dakota'},
    {value: 'TN', label: 'state.us.tennessee'},
    {value: 'TX', label: 'state.us.texas'},
    {value: 'UT', label: 'state.us.utah'},
    {value: 'VT', label: 'state.us.vermont'},
    {value: 'VI', label: 'state.us.virgin_islands'},
    {value: 'VA', label: 'state.us.virginia'},
    {value: 'WA', label: 'state.us.washington'},
    {value: 'WV', label: 'state.us.west_virginia'},
    {value: 'WI', label: 'state.us.wisconsin'},
    {value: 'WY', label: 'state.us.wyoming'}
]
